import respond from './respond'

const actionCreatorForActionType =
	actionType => (payload, meta) => respond(actionType, payload, meta)

const dispatcherForActionCreator =
	(actionCreatorName, triggerName, trigger) => ({
		[`${actionCreatorName}${triggerName.charAt(0).toUpperCase()}${triggerName.substring(1)}`]:
			dispatch => obj => dispatch(trigger(obj))
	})

const generateActionCreatorsForWorkflow =
	workflow => Object.keys(workflow)
		.reduce((actionCreators, actionType) => {
			// eslint-disable-next-line no-param-reassign, because this is exactly the right thing to be doing in a reducer
			actionCreators = {
				...actionCreators,
				[actionType.toLowerCase()]: actionCreatorForActionType(workflow[actionType])
			}
			return actionCreators
		}, {})

const generateActionCreators =
	(actionTypeGroup, actionCreatorName) => {
		let componentActionCreators = {}
		const sagaActionCreators = Object.keys(actionTypeGroup)
			.reduce((actionCreators, triggerName) => {
				const workflowActionCreators = generateActionCreatorsForWorkflow(actionTypeGroup[triggerName])
				componentActionCreators = {
					...componentActionCreators,
					...dispatcherForActionCreator(actionCreatorName, triggerName, workflowActionCreators.trigger)
				}
				// eslint-disable-next-line no-param-reassign, because this is exactly the right thing to be doing in a reducer
				actionCreators = {
					...actionCreators,
					[triggerName]: {
						...workflowActionCreators
					}
				}
				return actionCreators
			}, {})
		return {
			[actionCreatorName]: sagaActionCreators,
			...componentActionCreators
		}
	}

export default generateActionCreators



// WEBPACK FOOTER //
// ./src/redux/actionCreators/old_actions/utilities/generateActionCreators.js